import qs from 'qs';
import { deepMerge } from '../deepMerge/deepMerge';
import { isString } from '../isString/isString';
export const QUERY_PARSE_OPTIONS = {
    ignoreQueryPrefix: true,
    decoder: (str, defaultDecoder, charset, type) => {
        if (type === 'value') {
            return defaultDecoder(str, defaultDecoder, charset);
        }
        return str;
    },
};
/**
 * Parse query string into structure.
 *
 * Under the hood it uses npm package "qs", [https://www.npmjs.com/package/qs](https://www.npmjs.com/package/qs).
 *
 * @param {string} query Income query string.
 * @param {ParseSearchQueryOptions=} options Uses options from "qs", check "parse" method [https://github.com/ljharb/qs?tab=readme-ov-file#parsing-objects](https://github.com/ljharb/qs?tab=readme-ov-file#parsing-objects).
 * @returns {string}
 *
 * @example
 * // If params object is "?a=1", returns "{ a: 1 }"
 * parseSearchQuery('?a=1');
 */
export function parseSearchQuery(query, options = {}) {
    const parseOptions = deepMerge(QUERY_PARSE_OPTIONS, options);
    if (!isString(query)) {
        return {};
    }
    return qs.parse(decodeURIComponent(query), parseOptions);
}
